import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  constructor() {
  }

  show(config?: { message?: string; spinner?: string; }) {
   
  }

  hide() {
  }
}
